module.exports = __webpack_public_path__ + "img/logo-tanalei.dffea16f.svg";